import PaginationLoader from './PaginationLoader';

export default PaginationLoader;
